export default __webpack_public_path__ + "static/media/umbrella_ar 1.26647889.png";